<template>
  <div
    class="dropdown-list-children"
    :class="[isEnoughRightIndent ? 'dropdown-list-children--right' : 'dropdown-list-children--left']"
    :style="styles"
  >
    <slot />
  </div>
</template>

<script>
import { SIDE_MARGIN } from './dd-constants.js';
export default {
  name: 'DropdownCustomSidePosition',
  props: {
    parentSelected: {
      type: Object,
      default: function() { return null }
    },
    windowSize: {
      type: Object,
      default: null
    },
  },
  mounted() {
    this.calcTopIndent();
    this.calcSidePosition();
  },
  data() {
    return {
      offsetTop: 0,
      isEnoughRightIndent: true,
    }
  },
  computed: {
    styles() {
      return {
        transform: `translateY(${this.offsetTop}px)`
      }
    }
  },
  watch: {
    parentSelected() {
      this.calcTopIndent();
    },
    windowSize() {
      this.calcSidePosition();
    }
  },
  methods: {
    findParentNode() {
      return document.body.querySelector(`[data-js-id='${this.parentSelected?.key}']`);
    },
    findParentListNode() {
      const parentDom = this.findParentNode();
      if (!parentDom) return null;
      return parentDom.parentNode;
    },
    calcTopIndent() {
      const parentDom = this.findParentNode();
      const parentListDom = this.findParentListNode();
      if (!parentDom || !parentListDom) return;
      this.offsetTop = parentDom.offsetTop - parentListDom.scrollTop;
    },
    calcSidePosition() {
      const parentDom = this.findParentNode();
      if (!parentDom) return;
      const clientWidth = this.windowSize?.width || document.body.clientWidth;
      const { width, right } = parentDom.getBoundingClientRect();
      const rightIndent = clientWidth - right;
      this.isEnoughRightIndent = rightIndent > (width + SIDE_MARGIN);
    }
  }
};
</script>

<style scoped lang="scss">
.dropdown-list-children {
  position: absolute;
  width: 100%;
  top: 0;
}
.dropdown-list-children--right {
  left: 100%;
}
.dropdown-list-children--left {
  right: 100%;
}
.dropdown-list-children {
  ::v-deep {
    .dropdown_list {
      max-height: 300px;
    }
    .dropdown_list-wrap:hover & {
      will-change: transform;
    }
  }
}
</style>
